var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1988 0H17.8012L0 31.0204L5.22604 40H40.774L46 31.0204L28.1988 0Z",
    fill: "#E63537"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.909 31.3471L35.4936 33.7417C23.0817 31.456 10.5066 33.7417 10.3977 33.7417L8.16577 29.7145C8.22021 29.6601 15.6238 21.3879 20.6865 7.83691H25.2593C24.9326 10.3947 23.6806 13.5512 23.4628 13.9322C20.7409 20.0818 17.8013 24.9254 15.5149 28.1907C19.38 27.8641 24.7149 27.6464 30.4853 28.1362C30.1587 27.7009 29.8865 27.2655 29.6143 26.939C28.2534 26.8301 26.1303 26.6124 22.3196 26.7213L20.1965 22.9662C20.251 22.8573 23.8983 17.1975 26.0758 9.7961C27.0013 12.1362 28.0356 14.3131 29.0155 16.2723C28.2533 18.2859 27.4368 20.2451 26.5113 21.8233C29.1244 21.8777 31.193 22.0954 32.4995 22.3131C35.1125 26.5036 37.29 29.0614 37.7255 29.5512C37.78 29.6056 37.78 29.6601 37.78 29.7145L36.909 31.3471Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eb5b8d0dde9080a92b23f9ce209069ab.svg";
export { ForwardRef as ReactComponent };